<template>
    <div class="chat-group-card" @click.stop="onShowGroupInfo">
        <div class="card-body">
            <head-image :url="cardInfo.headImage" :name="cardInfo.groupName" radius="10%"></head-image>
            <div class="nick-name">
                {{ cardInfo.groupName }}
            </div>
        </div>
        <div class="card-footer">
            <div class="tip">群名片</div>
            <el-tag v-if="isExpired" type="warning">已过期</el-tag>
        </div>
    </div>
</template>
<script>
import HeadImage from '../common/HeadImage.vue'

export default {
    name: "chatUserCard",
    components: {
        HeadImage
    },
    props: {
        sendTime: {
            type: Number,
            default: null
        },
        cardInfo: {
            type: Object
        }
    },
    data() {
        return {}
    },
    methods: {
        onShowGroupInfo(e) {
            if (this.isExpired) {
                this.$message.warning("该名片已过期")
                return;
            }
            this.$http({
                url: `/group/find/${this.cardInfo.groupId}`,
                method: 'get'
            }).then(group => {
                let pos = {
                    x: e.x + 30,
                    y: e.y
                }
                this.$eventBus.$emit("openGroupInfo", group, this.cardInfo.token, pos);
            })
        }
    },
    computed: {
        isExpired() {
            if (!this.cardInfo.token || !this.cardInfo.token.expiredIn) {
                return true;
            }
            return new Date().getTime() > this.cardInfo.token.expiredIn
        }
    }
}
</script>
<style scoped lang="scss">
.chat-group-card {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background: rgba(255, 252, 243, 0.62);
    backdrop-filter: blur(24px) saturate(140%);
    -webkit-backdrop-filter: blur(24px) saturate(140%);
    border: 0.5px solid var(--glass-border);
    box-shadow:
        inset 0 1px 0 0 var(--glass-border-inner),
        0 1px 2px rgba(31, 31, 35, 0.04),
        0 8px 24px rgba(31, 31, 35, 0.06);
    border-radius: var(--radius-md);
    padding: 12px 16px;
    height: 90px;
    width: 200px;
    cursor: pointer;
    transition: all 0.18s cubic-bezier(0.32, 0.72, 0, 1);
    position: relative;
    overflow: hidden;
    text-align: left;

    &:hover {
        transform: translateY(-1px);
        box-shadow:
            inset 0 1px 0 0 var(--glass-border-inner),
            0 8px 20px rgba(91, 141, 238, 0.14);
        border-color: rgba(91, 141, 238, 0.3);
    }

    .card-body {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 10px;
        border-bottom: 0.5px solid var(--hairline-mid);
        padding-bottom: 8px;

        .nick-name {
            flex: 1;
            font-weight: 600;
            font-size: 15px;
            color: var(--im-text-color-primary);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.3;
        }
    }

    .card-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 6px;
        width: 100%;
        color: var(--im-text-color-light);
        font-size: 12px;
        text-align: left;

        .tip {
            flex: 1;
            font-weight: 500;
            color: var(--im-text-color-light);
            display: flex;
            align-items: center;
            gap: 4px;

            &::before {
                content: '';
                width: 4px;
                height: 4px;
                background: var(--aurora-blue);
                border-radius: 50%;
                opacity: 0.6;
            }
        }
    }
}
</style>
